import React from 'react';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';
import PasswordInput from '../password-input.js';


export default class UserScreen extends React.Component { 
    constructor(props) {
        super(props);
        const args = props.args === undefined ? {} : props.args
        var role = ''
        var email = ''
        var personname = ''
        var refid = ''
        var userid = null

        if (args.role != undefined) {
            role = args.role
        }

        if (args.email != undefined) {
            email = args.email
        }

        if (args.personname != undefined) {
            personname = args.personname
        }

        if (args.refid != undefined) {
            refid = args.refid
        }

        if (args.userid != undefined) {
            userid = args.userid
        }

        this.state = { login: email,
                    userid: userid,
                    email: email,
                    pass: '',
                    repass: '', 
                    personname: personname,
                    role: role,
                    refid: refid, 
                    isValid: true,
                    message: ""};
    
        this.handleChangePass = this.handleChangePass.bind(this);
        this.handleChangeRePass = this.handleChangeRePass.bind(this);
        this.handleChangeLogin = this.handleChangeLogin.bind(this);
        this.handleChangePersonName = this.handleChangePersonName.bind(this);
        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.save = this.save.bind(this);
    }

    handleChangeLogin(event) {
        this.setState({login: event.target.value});
    }

    handleChangeEmail(event) {
        this.setState({email: event.target.value});
    }

    handleChangePersonName(event) {
        this.setState({personname: event.target.value});
    }

    handleChangePass(event) {
        let isValid = this.validate(event.target.value, this.state.repass)
        let message = isValid ? "" : "Пароли не совпадают или пароль не соотвествует требованиям"
        this.setState({pass: event.target.value, isValid: isValid, message: message});
    }

    handleChangeRePass(event) {
        let isValid = this.validate(this.state.pass, event.target.value)
        let message = isValid ? "" : "Пароли не совпадают или пароль не соотвествует требованиям"
        this.setState({repass: event.target.value, isValid: isValid , message: message});
    }

    validate(pass, repass) {
        return pass.length >=8 && pass == repass
    }
    
    save(event) {
        const user = {id: this.state.userid, username: this.state.login, personname: this.state.personname, pass: this.state.pass, mail: this.state.email, role: this.state.role, refid: this.state.refid}

        BaseApi.post('/user', user, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            if (res.data.STATUS == "OK") {
                this.props.goback(this.props.args)
            } else {
                var message = ""

                if (res.data.ERROR == "USER_EXISTS") {
                    message = "Пользователь с таким имененм уже существует"
                } else {
                    message = "Произошла ошибка"
                }

                this.setState({isValid: false, errorMessage: message})
            }            
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }
    
    render () {
        const userExists = !!this.state.userid
        return (

        <div class = "container">   
            <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Пользователь"}/>
            <div className="row mt-4">
                <div className="col-lg-8">
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <div class="form-group">
                                <label for="login">Логин:</label>
                                <input 
                                    type="text" class="form-control" id="login" 
                                    value={this.state.login} 
                                    onChange={this.handleChangeLogin} 
                                    disabled={userExists}
                                />
                                
                                <label for="personname">Имя:</label>
                                <input 
                                    type="text" class="form-control" id="personname" 
                                    value={this.state.personname} 
                                    onChange={this.handleChangePersonName} 
                                    disabled={userExists}
                                />
                                
                                <label for="email">Email:</label>
                                <input 
                                    type="text" class="form-control" id="email" 
                                    value={this.state.email} 
                                    onChange={this.handleChangeEmail} 
                                    disabled={userExists}
                                />
                                
                                <label for="password">Новый пароль:</label>
                                <PasswordInput class="form-control" id="password" value={this.state.pass} onChange={this.handleChangePass} />
                                <label for="repassword">Повторите:</label>
                                <PasswordInput class="form-control" id="repassword"  value={this.state.repass} onChange={this.handleChangeRePass} />
                                {!this.state.isValid && <div class ="mt-5"><span style={{"color": "red"}}>{this.state.message}</span></div>} 
                            </div>
                        </div> 
                    </div>                       
                </div>
                <div className="col-lg-4 mt-4 mt-lg-0">
                    <div className="card shadow-sm">
                        <div className="card-body">
                            <button class="btn btn-primary w-100" onClick={this.save}>
                                {!userExists &&
                                    "Создать аккаунт"
                                }
                                {userExists &&
                                    "Сменить парлоль"
                                } 
                            </button>   
                        </div>    
                    </div> 
                </div>
            </div>
        </div> )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/user-screen.js